import {
  DangerButton,
  PositiveButton,
  Select,
  Space,
  Text,
} from '@procurify/ui'

import { useProcurifyIntl } from '@webapp/hooks'
import messages from '../messages'

interface IApprovalFormSectionProps {
  nextApproverOptions: { label: string; value: number }[]
  selectedNextApproverOption: { label: string; value: number } | null
  onSelectedNextApproverIdChange: (id: Nullable<number>) => void
  hasNextApproverChoices: boolean
  isFinalApproval: boolean
  isApproving: boolean
  isDenying: boolean
  onApprove: () => void
  onDeny: () => void
}

export const ApprovalFormSection = ({
  nextApproverOptions,
  selectedNextApproverOption,
  onSelectedNextApproverIdChange,
  hasNextApproverChoices,
  isFinalApproval,
  isApproving,
  isDenying,
  onApprove,
  onDeny,
}: IApprovalFormSectionProps) => {
  const intl = useProcurifyIntl()

  return (
    <Space direction='vertical' align='end'>
      <Space direction='horizontal' align='center'>
        {hasNextApproverChoices && !isFinalApproval ? (
          <Select
            options={nextApproverOptions}
            value={selectedNextApproverOption}
            onChange={(option) =>
              onSelectedNextApproverIdChange(option ? option.value : null)
            }
            placeholder={intl.formatMessage(messages.nextApproverPlaceholder)}
          />
        ) : (
          <Text>{intl.formatMessage(messages.finalApprovalMessage)}</Text>
        )}
        <DangerButton
          icon='times'
          onClick={onDeny}
          disabled={isApproving || isDenying}
        >
          {intl.formatMessage(messages.denyButton)}
        </DangerButton>
        <PositiveButton
          icon='approval'
          onClick={onApprove}
          disabled={isApproving || isDenying}
        >
          {intl.formatMessage(messages.approveButton)}
        </PositiveButton>
      </Space>
    </Space>
  )
}

ApprovalFormSection.displayName = 'ApprovalFormSection'
